export default __webpack_public_path__ + "static/media/notificationIcon.f068d991.svg";